interface LocalizedTitle {
  en: string;
  fr: string;
}

export interface HelpCenterReleaseLink {
  title: LocalizedTitle;
  path: string;
  releasedAt: string;
}

// Keep this list ordered from newest to oldest.
export const HELP_CENTER_RELEASE_LINKS: readonly HelpCenterReleaseLink[] = [
  {
    title: {
      en: "Release 4.4",
      fr: "Version 4.4",
    },
    path: "release4.4",
    releasedAt: "2026-10-19",
  },
  {
    title: {
      en: "Release 4.3",
      fr: "Version 4.3",
    },
    path: "release4.3",
    releasedAt: "2026-09-22",
  },
  {
    title: {
      en: "Release 4.2",
      fr: "Version 4.2",
    },
    path: "release4.2",
    releasedAt: "2026-08-26",
  },
  {
    title: {
      en: "Release 4.1",
      fr: "Version 4.1",
    },
    path: "release4.1",
    releasedAt: "2026-05-20",
  },
  {
    title: {
      en: "Release 4.0",
      fr: "Version 4.0",
    },
    path: "release4.0",
    releasedAt: "2026-04-07",
  },
  {
    title: {
      en: "Release 3.26",
      fr: "Version 3.26",
    },
    path: "release3.26",
    releasedAt: "2026-03-05",
  },
  {
    title: {
      en: "Release 3.25",
      fr: "Version 3.25",
    },
    path: "release3.25",
    releasedAt: "2026-02-12",
  },
];
